// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productImageBadgesStyles } from "@ces/Overrides/Components/ProductImageBadges";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color, hideElement } from "@ces/XDL/Utilities";
import { css } from "styled-components";

productImageBadgesStyles.imageContainer = {
    css: css`
        justify-content: left;
        gap: 8px;
        &:empty {
            ${hideElement}
        }
    `,
};

productImageBadgesStyles.imageItem = {
    css: css`
        justify-content: center;
        flex-basis: 24px;
        max-width: 24px;
        max-height: 24px;
        padding: 0;
        ${({ showName }: any) =>
            showName
                ? css`
                      padding-left: 2px;
                      border-radius: 2px;
                      max-width: unset;
                      flex-basis: unset;
                      background: linear-gradient(
                          225deg,
                          ${color("common.ui12")} 0,
                          ${color("common.ui7")} 95%,
                          ${color("common.ui12")} 100%
                      );
                      overflow: hidden;
                      img {
                          mix-blend-mode: lighten;
                          max-width: 24px;
                      }
                  `
                : ""}
    `,
};

productImageBadgesStyles.badgeName = {
    color: "common.white",
    size: 10,
    lineHeight: "16px",
    weight: fontConfig.weight.bold,
    css: css`
        height: 100%;
        align-items: center;
        display: flex;
        padding: 4px 8px;
    `,
};
